/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_Devices_SyncDeviceParameterModel } from '../models/BigClock_Api_Models_Devices_SyncDeviceParameterModel';
import type { BigClock_Api_Models_Devices_UpdateArticleModel } from '../models/BigClock_Api_Models_Devices_UpdateArticleModel';
import type { BigClock_Api_Models_Devices_UpdateModelModel } from '../models/BigClock_Api_Models_Devices_UpdateModelModel';
import type { BigClock_Api_Models_StandardTimeModel } from '../models/BigClock_Api_Models_StandardTimeModel';
import type { BigClock_Api_Models_StandardTimeOffsetModel } from '../models/BigClock_Api_Models_StandardTimeOffsetModel';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Api_Models_UpdateDevicePlaceModel } from '../models/BigClock_Api_Models_UpdateDevicePlaceModel';
import type { BigClock_Api_Models_UpdatePrivateDescriptionModel } from '../models/BigClock_Api_Models_UpdatePrivateDescriptionModel';
import type { BigClock_Application_Commands_AddDevice_AddDeviceCommand } from '../models/BigClock_Application_Commands_AddDevice_AddDeviceCommand';
import type { BigClock_Application_Queries_GetDevice_GetDeviceResponse } from '../models/BigClock_Application_Queries_GetDevice_GetDeviceResponse';
import type { BigClock_Application_Queries_GetDeviceDateTime_GetDeviceDateTimeRequestResponse } from '../models/BigClock_Application_Queries_GetDeviceDateTime_GetDeviceDateTimeRequestResponse';
import type { BigClock_Application_Queries_GetDeviceEvents_GetDeviceEventsResponse } from '../models/BigClock_Application_Queries_GetDeviceEvents_GetDeviceEventsResponse';
import type { BigClock_Application_Queries_GetDeviceStoredEvents_GetDeviceStoredEventsResponse } from '../models/BigClock_Application_Queries_GetDeviceStoredEvents_GetDeviceStoredEventsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DevicesService {
    /**
     * @param deviceId
     * @returns BigClock_Application_Queries_GetDevice_GetDeviceResponse Success
     * @throws ApiError
     */
    public static getApiDevices(
        deviceId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDevice_GetDeviceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @param deviceId
     * @returns any Success
     * @throws ApiError
     */
    public static deleteApiDevices(
        deviceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Devices/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevices(
        requestBody?: BigClock_Application_Commands_AddDevice_AddDeviceCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiDevicesDescriptionPrivate(
        deviceId: string,
        requestBody?: BigClock_Api_Models_UpdatePrivateDescriptionModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Devices/{deviceId}/description/private',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param controlBlockId
     * @param address
     * @param type
     * @returns any Success
     * @throws ApiError
     */
    public static getApiDevicesDeviceType(
        controlBlockId: string,
        address: number,
        type: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{controlBlockId}/device/{address}/type/{type}',
            path: {
                'controlBlockId': controlBlockId,
                'address': address,
                'type': type,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param address
     * @param type
     * @param serialNumber
     * @returns any Success
     * @throws ApiError
     */
    public static getApiDevicesDeviceTypeSerial(
        controlBlockId: string,
        address: number,
        type: number,
        serialNumber: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{controlBlockId}/device/{address}/type/{type}/serial/{serialNumber}',
            path: {
                'controlBlockId': controlBlockId,
                'address': address,
                'type': type,
                'serialNumber': serialNumber,
            },
        });
    }
    /**
     * @param deviceId
     * @returns BigClock_Application_Queries_GetDeviceDateTime_GetDeviceDateTimeRequestResponse Success
     * @throws ApiError
     */
    public static getApiDevicesTime(
        deviceId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDeviceDateTime_GetDeviceDateTimeRequestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{deviceId}/time',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevicesTime(
        deviceId: string,
        requestBody?: BigClock_Api_Models_StandardTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/time',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevicesTimeUtc(
        deviceId: string,
        requestBody?: BigClock_Api_Models_StandardTimeModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/time/utc',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevicesTimeTimezone(
        deviceId: string,
        requestBody?: BigClock_Api_Models_StandardTimeOffsetModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/time/timezone',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevicesTimeDaylightSaving(
        deviceId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/time/daylight-saving',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @returns any Success
     * @throws ApiError
     */
    public static postApiDevicesReboot(
        deviceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/reboot',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @param deviceId
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static postApiDevicesFirmwareUpload(
        deviceId: string,
        formData?: {
            file: Blob;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/firmware/upload',
            path: {
                'deviceId': deviceId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiDevicesPlace(
        deviceId: string,
        requestBody?: BigClock_Api_Models_UpdateDevicePlaceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Devices/{deviceId}/place',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiDevicesParametersSync(
        deviceId: string,
        requestBody?: BigClock_Api_Models_Devices_SyncDeviceParameterModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/parameters/sync',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiDevicesVisibility(
        deviceId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/visibility',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiDevicesArticle(
        deviceId: string,
        requestBody?: BigClock_Api_Models_Devices_UpdateArticleModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Devices/{deviceId}/article',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiDevicesModel(
        deviceId: string,
        requestBody?: BigClock_Api_Models_Devices_UpdateModelModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Devices/{deviceId}/model',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param deviceId
     * @param after
     * @param dateFrom
     * @param dateTo
     * @param pageSize
     * @returns BigClock_Application_Queries_GetDeviceEvents_GetDeviceEventsResponse Success
     * @throws ApiError
     */
    public static getApiDevicesEvents(
        deviceId: string,
        after?: string,
        dateFrom?: string,
        dateTo?: string,
        pageSize?: number,
    ): CancelablePromise<BigClock_Application_Queries_GetDeviceEvents_GetDeviceEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{deviceId}/events',
            path: {
                'deviceId': deviceId,
            },
            query: {
                'After': after,
                'DateFrom': dateFrom,
                'DateTo': dateTo,
                'PageSize': pageSize,
            },
        });
    }
    /**
     * @param deviceId
     * @returns BigClock_Application_Queries_GetDeviceStoredEvents_GetDeviceStoredEventsResponse Success
     * @throws ApiError
     */
    public static getApiDevicesEventsStored(
        deviceId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetDeviceStoredEvents_GetDeviceStoredEventsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Devices/{deviceId}/events/stored',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @param deviceId
     * @returns void
     * @throws ApiError
     */
    public static postApiDevicesEventsStoredReset(
        deviceId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Devices/{deviceId}/events/stored/reset',
            path: {
                'deviceId': deviceId,
            },
        });
    }
}
